"use client";

import { Alert } from "antd";
import { REGISTRATION_MESSAGES } from "@/lib/registrationHelpers";

export default function EventSettingsNotice({
  isTicketTransferable,
  compact = false,
}) {
  if (isTicketTransferable !== false) return null;

  return (
    <div className={compact ? "mb-3" : "mb-4"}>
      <Alert
        type="warning"
        showIcon
        message="Transfers not allowed"
        description={REGISTRATION_MESSAGES.TRANSFER_NOT_ALLOWED}
      />
    </div>
  );
}
